import React from "react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "./card";
import { Button } from "./button";

/**
 * A simple, reusable alert dialog component.
 * @param {object} props
 * @param {boolean} props.open - Controls if the dialog is visible.
 * @param {function} props.onOpenChange - Function to call when the dialog should be closed.
 * @param {string} props.title - The title of the dialog.
 * @param {React.ReactNode} props.children - The main content of the dialog.
 * @param {React.ReactNode} props.footer - The footer content, typically buttons.
 */
export function AlertDialog({ open, onOpenChange, title, children, footer }) {
  if (!open) {
    return null;
  }

  return (
    // Backdrop
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={() => onOpenChange(false)}
    >
      {/* Dialog Content */}
      <Card
        className="w-full max-w-md m-4"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the card
      >
        <CardHeader>
          <CardTitle>{title}</CardTitle>
        </CardHeader>
        <CardContent>{children}</CardContent>
        {footer && (
          <CardFooter className="flex justify-end gap-2">{footer}</CardFooter>
        )}
      </Card>
    </div>
  );
}
